import * as React from "react";
import UhaulStore from "../CustomRedux/UhaulStore";
import ExceptionLogger from "../ExceptionHelper";
import GetLiveChatHeader from "../../src/LiveChatHeaderHelper.js";
import { Manager } from "@twilio/flex-ui";

export class MonitoringOnlyToggle extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isMonitoringOnly: false }
    }

    enableMonitoringOnly = (isEnabled) => {
        const supervisorUser = UhaulStore.getState().UhaulReducer.currentUser;
        // const liveChatApiUrl = UhaulStore.getState().UhaulReducer.config.liveChatApiUrl;
        const serviceBaseUrl = supervisorUser.serviceBaseUrl;
        const workerAttributes = supervisorUser.attributes;

        if(workerAttributes?.types != null)
        {
            if(isEnabled && !workerAttributes.types.includes("monitoring-only"))
            {
                workerAttributes.types.push("monitoring-only");
                this.setState({isMonitoringOnly: true});
            }
            else
            {
                if(workerAttributes.types.includes("monitoring-only"))
                {
                    const index = workerAttributes.types.indexOf("monitoring-only");
                    if (index > -1) {
                        workerAttributes.types.splice(index, 1);
                    }
                    this.setState({isMonitoringOnly: false});
                }
            }
            

            fetch(serviceBaseUrl + 'update-worker',
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: "POST",
                body: new URLSearchParams({
                    Token: Manager.getInstance().user.token,
                    newAttributes: JSON.stringify(workerAttributes),
                    workerID: supervisorUser.sid
                })
            }).catch((err) => {
                console.log("FETCH ERROR: ", err);
                ExceptionLogger(err, "enableMonitoringOnly", "Error with UpdateWorker", "",`${supervisorUser.sid}`);
            });

            //PUT: update the worker's attributes and capacity
            // fetch(liveChatApiUrl + 'Workers',
            // {
            //     headers: GetLiveChatHeader(),
            //     method: "PUT",
            //     body: JSON.stringify({
            //         WorkerID: supervisorUser.sid,
            //         NewAttributes: JSON.stringify(workerAttributes)
            //     })
            // }).catch((err) => {
            //     console.log("FETCH ERROR: ", err);
            //     ExceptionLogger(err, "enableMonitoringOnly", "Error with UpdateWorker", "",`${supervisorUser.sid}`);
            // });
        }
    }

    render(){
        const supervisorUser = UhaulStore.getState().UhaulReducer.currentUser;
        const itemProps = this.props["data-items"]
        const thisAgent = itemProps?.worker;
        const showMonitoringBtn = itemProps?.worker?.sid === supervisorUser?.sid;
        const isToggled = this.state.isMonitoringOnly || thisAgent?.attributes?.types?.includes("monitoring-only")

        return (
            <div className="waitingTaskBacklogs">
                {showMonitoringBtn ? (
                        <label className="switch">
                            <input type="checkbox" id="togBtn" defaultChecked={isToggled}/>
                            <div className="slider round">
                                <span className="on" onClick={() => this.enableMonitoringOnly(false) }>Only Monitoring</span>
                                <span className="off" onClick={() => this.enableMonitoringOnly(true) }>Default</span>
                            </div>
                        </label>) : ""
                }
            </div>
        )
    }
}
